import React from 'react';
import { useCssHandles } from '../../../utils/functions';

const SELLERS_CSS_HANDLES = ['sellerBuyContainer'] as const;

interface Props {
	isOneClickBuy?: boolean;
	blocks?: any;
	componentId?: string;
	blockClass?: string;
}

function SellerAddToCart({ isOneClickBuy, blocks, componentId, blockClass }: Props) {
	const { handles }: any = useCssHandles(`vtex-seller-selector-0-x`, SELLERS_CSS_HANDLES, blockClass);

	return (
		<div
			data-selection={componentId}
			className={`${handles.sellerBuyContainer} items-center tc br2 ph6 pv4 ma0 w-100-s w-20-m`}
		>
			{blocks?.length ? (
				blocks[0]
			) : (
				<button
					className="vtex-button bw1 ba fw5 v-mid relative pa0 lh-solid br2 min-h-regular t-action bg-action-primary b--action-primary c-on-action-primary hover-bg-action-primary hover-b--action-primary hover-c-on-action-primary pointer w-100 "
					type="button"
				>
					<div
						className="vtex-button__label flex items-center justify-center h-100 ph6 w-100 border-box "
						style={{ paddingTop: '0.25em', paddingBottom: '0.32em' }}
					>
						<span className="vtex-store-components-3-x-buyButtonText">Adicionar ao carrinho</span>
					</div>
				</button>
			)}
		</div>
	);
}

export default SellerAddToCart;
